import React from 'react';
import { useTranslation } from 'react-i18next';

function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="text-center py-4 bg-transparent text-gray-700 mt-8">
      <p className="text-sm">
        <a
          href="https://thetipsyou.fr"
          target="_blank"
          rel="noopener noreferrer"
          className="text-black underline"
        >
          {t('learnMoreButton', 'Accueil')}
        </a>
      </p>
      <p className="text-xs mt-2">© {new Date().getFullYear()} HumanX. All rights reserved.</p>
    </footer>
  );
}

export default Footer;
